function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Credit Card expiry
 * 
 */
import React, { Component } from 'react';
import Select from '../../../../components/select/Select';
import ErrorMessage from '../../../../components/error-message/ErrorMessage';
import { expiryMonth, expiryYear } from '../../../../actions/index';
import { connect } from 'react-redux';
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MONTH_OPTIONS = [{
  title: '--',
  value: ''
}, {
  title: '01',
  value: '01'
}, {
  title: '02',
  value: '02'
}, {
  title: '03',
  value: '03'
}, {
  title: '04',
  value: '04'
}, {
  title: '05',
  value: '05'
}, {
  title: '06',
  value: '06'
}, {
  title: '07',
  value: '07'
}, {
  title: '08',
  value: '08'
}, {
  title: '09',
  value: '09'
}, {
  title: '10',
  value: '10'
}, {
  title: '11',
  value: '11'
}, {
  title: '12',
  value: '12'
}];
const YEAR_OPTIONS = [{
  title: '----',
  value: ''
}];
for (let i = 0; i < 9; i++) {
  const year = moment();
  year.add(i, 'years');
  YEAR_OPTIONS.push({
    title: year.format('YYYY'),
    value: year.format('YY')
  });
}
class Expiry extends Component {
  render() {
    const {
      expiryMonth,
      expiryYear,
      creditCard,
      gateway
    } = this.props;
    const {
      expiry_month,
      expiry_year
    } = creditCard;
    const error = expiry_month?.error || expiry_year?.error ? true : false;
    let year = expiry_year && expiry_year.value && typeof expiry_year.value === 'string' ? expiry_year.value : '';
    let month = expiry_month && expiry_month.value && typeof expiry_month?.value === 'string' ? expiry_month.value : '';
    const date = moment(new Date(parseInt(`20${year}`), parseInt(month) - 1));
    const pastExpiry = moment().isAfter(date);
    const message = pastExpiry ? 'Your credit card has expired.' : error ? 'Expiry month and year are required' : '';
    const monthName = gateway.name === 'windcave' ? 'ExpiryMonth' : gateway.name === 'nab-securepay' ? 'EPS_EXPIRYMONTH' : 'expiry_month';
    const yearName = gateway.name === 'windcave' ? 'ExpiryYear' : gateway.name === 'nab-securepay' ? 'EPS_EXPIRYYEAR' : 'expiry_year';
    const monthValue = {
      [monthName]: {
        ...creditCard.expiry_month
      }
    };
    const yearValue = {
      [yearName]: {
        ...creditCard.expiry_year
      }
    };
    return /*#__PURE__*/_jsxs("div", {
      className: "form-element-container expiry-date",
      children: [/*#__PURE__*/_jsx("span", {
        className: "label",
        children: "Credit card expiry"
      }), /*#__PURE__*/_jsx(Select, {
        label: "Expiry month",
        name: monthName,
        handleChange: expiryMonth,
        onBlur: expiryMonth
        // $FlowFixMe
        ,
        values: monthValue,
        section: "",
        options: MONTH_OPTIONS
      }), /*#__PURE__*/_jsx("div", {
        className: "slash",
        children: "/"
      }), /*#__PURE__*/_jsx(Select, {
        label: "Expiry year",
        name: yearName,
        handleChange: expiryYear,
        onBlur: expiryYear
        // $FlowFixMe
        ,
        values: yearValue,
        section: "",
        options: YEAR_OPTIONS
      }), /*#__PURE__*/_jsx(ErrorMessage, {
        error: error,
        message: message
      })]
    });
  }
}
_defineProperty(Expiry, "defaultProps", {
  expiryMonth: () => null,
  expiryYear: () => null,
  creditCard: {
    expiryMonth: {
      error: false,
      required: true,
      value: '',
      valid: null
    },
    expiryYear: {
      error: false,
      required: true,
      value: '',
      valid: null
    }
  },
  gateway: {
    name: 'windcave'
  }
});
const mapStateToProps = ({
  creditCard
}) => {
  return {
    creditCard
  };
};
const mapDispatchToProps = dispatch => {
  return {
    expiryMonth: value => {
      dispatch(expiryMonth(value));
    },
    expiryYear: value => {
      dispatch(expiryYear(value));
    }
  };
};
const VisibleExpiry = connect(mapStateToProps, mapDispatchToProps)(Expiry);
export default VisibleExpiry;